import { createSlice } from "@reduxjs/toolkit";
import { IAddTaskSlice } from "../../models/agent/Tasks/addTask";
import { Policies } from "../CustomerDetailsList/CustomerDetailsList";
import {
  PostCustomerDetails,
  PostCustomerPolicies,
} from "./CustomerDetailsListActions";
import { ICustomerPoliciesSlice } from "./customerDetailsListType";

const initialState: ICustomerPoliciesSlice = {
  policyCount: "",
  policyList: [],
  customerDetails: {
    carrier: "",
    customerId: "",
    customerName: "",
    customerSurName: "",
    emailInfo: "",
    phoneInfo: "",
    system: "",
  },
};
const customerPoliciesSlice = createSlice({
  name: "customerPolicies",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(PostCustomerPolicies.fulfilled, (state, { payload }) => {
      state.policyList = payload.data ? payload.data.policyList : [];
      state.policyCount = payload.data ? payload.data.policyCount : "";
    });
    builder.addCase(PostCustomerDetails.fulfilled, (state, { payload }) => {
      state.customerDetails = payload.data;
    });
  },
});

export default customerPoliciesSlice.reducer;
